export default __webpack_public_path__ + "static/media/go_live_btn.ee05dc4a.svg";